import React from "react";
import FormCard from "../FormComponents/FormCard";
import AlertBanner from "../FormComponents/AlertBanner";
import Icon from "../Icons/Icon";
import { HOTEL_DATA } from "../../constants/scheduleData";

/**
 * Step 4: Hotel Reservation Information
 *
 * This step displays hotel options and reservation details.
 * Can be integrated with API to fetch dynamic hotel data.
 */
const Step4 = ({ hotels = HOTEL_DATA }) => {
  return (
    <div className="form-page">
      <div className="form-page-header">
        <h2 className="form-page-title">Hotel Reservation Information</h2>
      </div>

      <FormCard>
        <AlertBanner type="info">
          We have negotiated special rates at Bally's Atlantic City Hotel and Casino and the Sheraton. The rates shown below are valid through
          the room deadline which varies by hotel. We also offer a FREE shuttle
          service to and from the approved Arett hotel(s) during all show hours.
          For SPECIAL RATES, you must book directly with the hotels using the
          links or phone numbers and Group name/Codes provided.
        </AlertBanner>
      </FormCard>

      {hotels.map((hotel, i) => (
        <FormCard key={i}>
          <div
            className="hotel-section-header"
            style={{
              margin: "-24px -24px 0",
              borderRadius: "10px 10px 0 0",
              borderBottom: "1px solid var(--neutral-200)",
            }}
          >
            <div className="hotel-name" style={{ color: hotel.color }}>
              {hotel.name}
            </div>
            <div className="hotel-address">{hotel.address}</div>
          </div>
          <div style={{ marginTop: 16 }}>
            <div className="hotel-table-wrapper">
              <table className="hotel-table">
                <thead>
                  <tr>
                    <th style={{ background: hotel.color }}>Date / Detail</th>
                    <th style={{ background: hotel.color }}>Base Room Rates</th>
                  </tr>
                </thead>
                <tbody>
                  {hotel.rates.map((r, ri) => (
                    <tr key={ri}>
                      <td>{r.night}</td>
                      <td
                        style={{
                          fontWeight:
                            r.night === "Group Code" || r.night === "Group Name"
                              ? 700
                              : 400,
                        }}
                      >
                        {r.rate}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td>Booking Link</td>
                    <td>
                      <a
                        className="link"
                        href={hotel.bookingUrl || "#!"}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: hotel.color }}
                      >
                        {hotel.bookingLink}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-small mt-8">{hotel.note}</p>
          </div>
        </FormCard>
      ))}

      <FormCard title="Airport Shuttle" icon={<Icon name="tag" size={14} />}>
        <p style={{ fontSize: 14, marginBottom: 16 }}>
          If you require a shuttle from the airport please read the guidelines
          below and then use the form provided to sign-up
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <div className="flex-row">
            <span style={{ fontWeight: 600, minWidth: 200, fontSize: 14 }}>
              Airport Shuttle Guidelines
            </span>
            <a className="link" href="http://catalogs.arett.com/bookcase/zhuri" target="_blank" rel="noreferrer">
              Click to read the airport shuttle guidelines
            </a>
          </div>
          <div className="flex-row">
            <span style={{ fontWeight: 600, minWidth: 200, fontSize: 14 }}>
              Vendor Shuttle Sign-up Form
            </span>
            <a className="link" href="https://forms.office.com/r/uKTMtdDRqn" target="_blank" rel="noreferrer">
              Click to sign-up for your the airport shuttle
            </a>
          </div>
        </div>
      </FormCard>
    </div>
  );
};

export default Step4;
